import { Box, Container, Grid, Sheet, Typography } from '@mui/joy';
import {
    ChatsCircle,
    Devices,
    Megaphone,
    Phone,
    ShieldCheck,
    Sticker
} from '@phosphor-icons/react';
import { FadeIn } from './FadeIn';

const features = [
    {
        icon: ChatsCircle,
        title: 'Сообщения',
        text: 'Личные и групповые чаты с фото и файлами. Быстро и привычно.',
    },
    {
        icon: Megaphone,
        title: 'Микроблог',
        text: 'Делитесь записями в общей ленте: тексты, фотографии, лайки и комментарии.',
    },
    {
        icon: Phone,
        title: 'Звонки',
        text: 'Аудио- и видеозвонки прямо из чата. Когда переписки уже мало.',
    },
    {
        icon: Sticker,
        title: 'Стикеры',
        text: 'Фирменные наборы стикеров. Немного иронии и эмоций для ваших чатов.',
    },
    {
        icon: Devices,
        title: 'Все платформы',
        text: 'Веб-версия, iOS и Android. Начните на телефоне — продолжите за компьютером.',
    },
    {
        icon: ShieldCheck,
        title: 'Безопасность',
        text: 'Защита данных, модерация контента, минимум персональных данных.',
    },
];

export function FeaturesSection() {
    return (
        <Container maxWidth="lg" id="features" sx={{ scrollMarginTop: '88px' }}>
            <Box sx={{ my: { md: 12, xs: 6 } }}>
                <FadeIn>
                    <Typography
                        level="h2"
                        sx={{ fontWeight: 700, textAlign: 'center', fontSize: { xs: '1.7rem', md: '2.5rem' }, mb: '2rem !important' }}
                    >
                        Всё нужное под рукой
                    </Typography>
                </FadeIn>
                <Grid container spacing={3}>
                    {features.map((f, i) => (
                        <Grid key={f.title} xs={12} sm={6} md={4}>
                            <Box sx={{
                                display: 'flex',
                                height: '100%',
                                flex: 1
                            }}>
                                <FadeIn delay={i * 0.08}>
                                    <Sheet
                                        variant="soft"
                                        sx={{
                                            p: 3.5,
                                            height: '100%',
                                            borderRadius: '24px',
                                            backgroundColor: 'rgba(89, 160, 244, 0.07)',
                                            transition: '.25s ease',
                                            '&:hover': {
                                                transform: 'translateY(-4px)',
                                                backgroundColor: 'rgba(69, 147, 240, 0.15)',
                                            },
                                        }}
                                    >
                                        <Box
                                            sx={(theme) => ({
                                                width: 52,
                                                height: 52,
                                                borderRadius: '16px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: 'rgba(89, 160, 244, .3)',
                                                color: 'var(--joy-palette-primary-500)',
                                                mb: 2,
                                                [theme.getColorSchemeSelector('dark')]: { color: '#fff' },
                                            })}
                                        >
                                            <f.icon size={28} weight="fill" />
                                        </Box>
                                        <Typography level="title-lg" sx={{ fontWeight: 700, mb: 1 }}>
                                            {f.title}
                                        </Typography>
                                        <Typography level="body-md" sx={{ color: 'text.secondary' }}>
                                            {f.text}
                                        </Typography>
                                    </Sheet>
                                </FadeIn>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Container>
    );
}
